<template>
  <div class="content">
    <div class="ai-tabs tabs">
      <div class="actions__left-tilte">
        <b>对齐VR列表</b>
      </div>
      <div class="ai-input-group actions__right">
        <input type="text" v-model.trim="serchInput" @keyup.enter="clickSearch" class="ai-input ai-input-group__input actions__search-input" placeholder="请输入搜索内容">
        <div class="ai-button ai-input-group__button actions__search-btn">
          <i class="material-icons" @click="clickSearch">search</i>
        </div>
        <div class="ai-button ai-button--primary new-sub-account actions__add-btn" @click="creatNewVR">
          新建数据
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <table class="table">
        <thead>
          <tr>
            <th>场名称</th>
            <th>VR ID</th>
            <th>Merge_id</th>
            <th>状态</th>
            <!-- <th>详情</th> -->
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in subaccounts" :key="index">
            <td style="width:10%">{{ item.name }}</td>
            <td style="width:20%">{{ item.vr_id }}</td>
            <td style="width:15%">{{ item.merge_id }}</td>
            <td style="width:10%">{{ ListStatus(item.status) }}</td>
            <!-- <td style="width:10%">{{ item.cmap }}</td> -->
            <td style="width:10%">{{ item.create_time | timeFormatter }}</td>
            <td style="width:20%">
              <div class="ai-button ai-button--text ai-button--text--primary" style="margin-right:10px;" @click="BindVR(item)">
                {{ ActivityText(item) }}
              </div>
              <!-- <div class="ai-button ai-button--text ai-button--text--primary"
                   style="margin-right:10px;"
                   @click="reDo(item)">
                重跑
              </div> -->
              <div class="ai-button ai-button--text ai-button--text--primary" style="margin-right:10px;" @click="Edit(item)">
                编辑
              </div>
              <div class="ai-button ai-button--text ai-button--text--danger" style="margin-right:10px;" @click="Delete(item)">
                删除
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <AiPagination v-model="currentPage" class="pagination" :total-page-count="totalPageCount" @change="getData" />

    <AiDialog class="progress-dialog" width="441" :visible.sync="addUIvisible" @close="closeAddDialog">
      <div slot="header" class="dialog__header">
        新建VR
      </div>

      <div class="create-sub-dialog__creatARcontent">
        <div style="padding:20px">
          <b>VR 名字</b>
          <el-input v-model="VRname" placeholder="请输入VR 名字" style="margin-top:20px;" />
        </div>
      </div>
      <div slot="footer" class="dialog__footer">
        <div style="margin-left: 20px;width: 60px;" class="ai-button ai-button--primary" @click="addVR">
          确 定
        </div>
        <div style="margin-left: 20px;width: 60px;" class="ai-button" @click="closeAddDialog">
          取 消
        </div>
      </div>
    </AiDialog>
  </div>
</template>

<script>

import moment from 'moment';
const createSuccess = require('@/assets/views/users/create_success.svg');
const deleteSuccess = require('@/assets/views/users/delete_success.svg');
export default {
  filters: {
    timeFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss');
    }
  },
  data() {
    return {
      serchInput: '',
      subaccounts: [],
      totalPageCount: 1,
      totalSize: 20,
      currentPage: 1,
      addUIvisible: false,
      VRname: '',
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async addVR() {

      if (this.VRname === '') {
        this.$element.message.error('请输入名字');
        return
      }


      let str = "/mesh/merge/add"
      let pamras = {
        "name": this.VRname,
      }
      try {
        const { data: { data } } = await this.$http.post(str, pamras);
        // const { data: { data } } = await this.$http.post('/admin/list-subaccounts', params);
        console.log('------data--------------------', data);
        if (data) {
          this.$message.basic({
            message: '添加成功!',
            icon: createSuccess
          });
          this.addUIvisible = false;
          this.getData();
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    closeAddDialog() {
      this.addUIvisible = false;
    },
    creatNewVR() {
      this.addUIvisible = true;
    },
    clickSearch() {
      this.currentPage = 1
      this.totalSize = 20
      this.getData()
    },
    Edit(item) {
      // item={id:'1',vr:'asdf',merge_id:'asdfsad340'}
      //   this.$router.push(`/x/mapAlignments/${item.merge_id}/editor`,item);
      //  this.$router.push({name:`mapAlignment`,params:item});query
      this.$router.push({ path: `/x/mapAlignments/${item.merge_id}/editor`, query: item });
    },
    async getData() {
      let str = "/admin/ar?page=" + this.currentPage + '&page_size=10';
      str = "/mesh/merge/list"
      let pamras = {
        "page_num": this.currentPage,
        "size": this.totalSize,
        "search": this.serchInput
      }
      try {
        const { data: { data } } = await this.$http.post(str, pamras);
        // const { data: { data } } = await this.$http.post('/admin/list-subaccounts', params);
        console.log('------data--------------------', data);
        if (data) {
          this.subaccounts = data.merges;
          this.currentPage = data.page_num;
          this.totalPageCount = (data.count / this.totalSize) + 1;
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    ActivityText() {

    },
    ListStatus(status) {
      // 0未拼接，1拼接中，2成功，3失败

      switch (status) {
        case 0:
          return '未拼接';
          break
        case 1:
          return '拼接中';
          break
        case 2:
          return '成功';
          break
        case 3:
          return '失败';
          break
      }
    },
    BindVR() {

    },
    async Delete(item) {

      this.$confirm({
        title: '确认要删除这组数据吗?',
        message: '删除将会终止正在进行的处理工作，且无法恢复!'
      }).then(async () => {
        var str = "/mesh/merge/delete"
        let pamras = { "merge_id": item.merge_id }
        try {
          const { data: { data } } = await this.$http.post(str, pamras);
          if (data) {
            this.$message.basic('删除成功！');
            this.getData();
          }
        } catch (error) {
          this.$message.basic(error.error_msg);
        }
      }).catch(() => { });

    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  margin: 10px 0;
  justify-content: space-between;
}

.actions {
  margin: 0 40px;
  width: 0 px;

  &__right {
    margin-right: 40px;
  }

  &__left-tilte {
    margin-left: 40px;
    font-family: "微软雅黑", serif;
    font-size: 24px;
    color: #888;
  }

  &__add-btn {
    width: 89px;
    height: 22px;
    font-size: 11px;
    margin-left: 12px;

    .material-icons {
      margin-right: 0;
      font-size: 14px;
    }
  }

  &__search-input {
    width: 183px;
    height: 22px;
  }

  &__search-btn {
    width: 22px;
    height: 22px;

    .material-icons {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
}

.table-wrapper {
  margin: 0 40px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;

  tr {
    height: 50px;
  }

  th {
    border: 0;
    font-size: 14px;
    color: #888;
  }

  thead {
    th {
      background-color: #ddeffb;

      &:first-child {
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-top-right-radius: 4px;
      }
    }
  }

  tbody {
    td {
      background-color: white;
      border-bottom: 1px solid #eee;
    }

    tr:last-child td {
      border-bottom: 0;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 4px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 4px;
    }
  }

  td {
    text-align: center;
    color: #888;
    font-size: 14px;
  }
}

.dialog__footer {
  position: absolute;
  left: 30%;
}

.dialog__header {
  height: 50px;
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-weight: 500;
  color: #6c6c6c;
}
</style>

